export const isDevelopment = import.meta.env.MODE !== 'production';

export function parseAst(code: string) {
  // @ts-ignore
  return acorn.parse(code, {
    ecmaVersion: 6,
    locations: true
  });
}
